import React from 'react';
import AlertModal from './alert-modal';

interface Props {
  message: string;
  title?: string;
  onClose?: () => void;
}

const AlertModalContext = React.createContext<(options: Props) => void>(() => { });

export const useAlertModal = () => React.useContext(AlertModalContext);

/**
 * Esse componente precisa estar presente no App.tsx como um wrapper das págians da aplicação.
 * Não importa a hierarquia, o importante é que as páginas que usarão o hook estão sob a hierarquia do AlertModalProvider.
 * @param props 
 */
export const AlertModalProvider = (props: any) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [dialogProps, setDialogProps] = React.useState<Props>();

  const openModal = (options: Props) => {
    setDialogProps(options);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    dialogProps?.onClose && dialogProps.onClose();
  }

  return (
    <>
      <AlertModalContext.Provider
        value={openModal}
        children={props.children}
      />

      <AlertModal
        isOpen={isOpen}
        onClose={closeModal}
        title={dialogProps?.title}
        message={dialogProps?.message || ''}
      />
    </>
  );
};